'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { PropertyDetailListing } from '../types';
import type { ApartmentReviews, BuildingReviewsSnapshot } from '@/src/lib/api/endpoints/apartmentReviews';
import { useApartmentReviews } from '@/src/lib/hooks/query/useApartmentReviews';

const ReviewsContext = createContext<{ lotId: string; reviews: ApartmentReviews | null }>({ lotId: '', reviews: null });

export function ApartmentReviewsProvider({
  listing,
  pdpType,
  snapshot,
  children,
}: {
  listing: PropertyDetailListing;
  pdpType: 'unit' | 'building';
  snapshot?: BuildingReviewsSnapshot;
  children: ReactNode;
}) {
  const reviews = useApartmentReviews(listing, pdpType, snapshot);
  return (
    <ReviewsContext.Provider value={{ lotId: listing.maloneLotIdEncoded ?? '', reviews }}>
      {children}
    </ReviewsContext.Provider>
  );
}

export const useApartmentReviewsContext = () => useContext(ReviewsContext);
